import { auth } from "../firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";

export function getToken() {
  return localStorage.getItem("access_token");
}

export function setToken(token) {
  localStorage.setItem("access_token", token);
}

export function clearToken() {
  localStorage.removeItem("access_token");
}

export function syncFirebaseAuth(onChange) {
  return onAuthStateChanged(auth, async (user) => {
    if (user) {
      const idToken = await user.getIdToken();
      setToken(idToken);
    } else {
      clearToken();
    }
    if (onChange) onChange(user);
  });
}

export async function firebaseLogout() {
  await signOut(auth);
  clearToken();
}

// No backend - removed backendUrl()
export default { getToken, setToken, clearToken, syncFirebaseAuth, firebaseLogout };
